module.exports = __webpack_public_path__ + "static/media/final_03.c65cb38e.jpg";